import React, { useState } from "react";
import { Card, CardContent, Switch } from "@mui/material";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import "../ApplicantsNewDashboard.css";
import CardTitle from "../CardTitle/CardTitle";

const PieChartWidgetCard = ({
  card,
  showToggle = false,
  switchChange,
  editMode,
  handleSaveCardTitle,
  handleDeleteCard,
  handleEditCard,
  handleCardTitle,
  cardTitleChangeId,
}) => {
  const data = card.data;
  const [toggle, switchToggle] = useState(false);

  const sanitizedData = (data ?? [])
    .filter((item) => item && item.value != null)
    .map((item, idx) => ({
      id: item.id ?? idx,
      value: item.value,
      label: item.label ?? String(item.value),
    }));

  const chartData = sanitizedData.filter((item) => item.value > 0);
  const totalCount = chartData.reduce((acc, curr) => acc + curr.value, 0);

  // const totalCount = sanitizedData.reduce((acc, curr) => acc + curr.value, 0);

  return (
    <Card className="dashboard__card">
      <CardTitle
        card={card}
        editMode={editMode}
        handleSaveCardTitle={handleSaveCardTitle}
        handleDeleteCard={handleDeleteCard}
        handleEditCard={handleEditCard}
        handleCardTitle={handleCardTitle}
        cardTitleChangeId={cardTitleChangeId}
      />
      <CardContent style={{ position: "relative" }}>
        <div style={{ textAlign: "right", height: "38px" }}>
          {showToggle && (
            <div className="switch-container" id="dashboardBtn">
              <span className="text">Individual</span>
              <Switch
                className="activeBtns"
                checked={toggle}
                name="pieChartIndividualORTeam"
                onChange={() => {
                  const value = !toggle;
                  switchToggle(value);
                  switchChange(value);
                }}
              />
              <span className="text">Team</span>
            </div>
          )}
        </div>
        {totalCount > 0 ? (
          <PieChart
            height={310}
            colors={[
              "#9c9494",
              "#8ba3bc",
              "#9fbb7d",
              "#dcc882",
              "#e76f51",
              "#2a9d8f",
              "#c88d68",
              "#6e6a52",
              "#5c6c74",
              "#6c5444",
              "#c9c9c9",
            ]}
            series={[
              {
                data: chartData ?? [],
                innerRadius: 2.5,
                outerRadius: 150,
                paddingAngle: chartData.length > 1 ? 0.5 : 0,
                cornerRadius: 2,
                startAngle: -180,
                endAngle: 180,
                cx: (chartData?.length ?? 0) > 11 ? 185 : 185,
                cy: 150,
                arcLabel: (params) => `(${params.value})` ?? "", //${params.label}
                arcLabelMinAngle: 50,
                arcLabelRadius: "50%",
              },
            ]}
            sx={{
              [`& .${pieArcLabelClasses.root}`]: {
                fontWeight: "bold",
              },
            }}
          />
        ) : (
          <div className="dashboard__card-no-data-container">
            No data available
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(PieChartWidgetCard);
